import React, { useEffect } from "react";
import { Row, Form, Input, Typography } from "antd";

const { TextArea } = Input;
const { Text } = Typography;

const Description = ({ state = {}, row = 6, readOnly, placeholder, ...props }) => {
  const { data, form, rules, onChange, keyName } = state;

  //for sync antd with state
  useEffect(() => {
    form?.setFieldsValue({ [keyName]: data });
  }, [data]);

  return (
    <Form form={form} layout="vertical" style={{ width: "100%" }}>
      {readOnly && !data ? (
        `no ${keyName} available`
      ) : (
        <Form.Item name={keyName} rules={rules}>
          <TextArea
            value={data}
            rows={row}
            maxLength={300}
            showCount
            placeholder={placeholder}
            readOnly={readOnly}
            onChange={(e) => {
              onChange({ [keyName]: e?.target?.value });
            }}
          />
        </Form.Item>
      )}
    </Form>
  );
};

export default Description;
